import React from "react";
import "./NotFoundPage.scss";

const NotFoundPage = () => {
  return (
    <div
      data-testid="NotFoundPage"
      className={`container-fluid container-xl container-lg my-0 mx-auto px-0`}
    >
      <div className="main-container row">
        <h1 className="col-12 mb-5 mt-5 text-center heading1">Not Found</h1>
      </div>
    </div>
  );
};

export default NotFoundPage;
